import { render, staticRenderFns } from "./paradigm.vue?vue&type=template&id=10e09ee3&scoped=true"
import script from "./paradigm.vue?vue&type=script&lang=js"
export * from "./paradigm.vue?vue&type=script&lang=js"
import style0 from "./paradigm.vue?vue&type=style&index=0&id=10e09ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e09ee3",
  null
  
)

export default component.exports